import { DynamicFormAnswer, DynamicFormAnswers, DynamicFormsApiService } from '@api_patient/dynamic_forms_api.service';
import { FormGraphApiModel } from '@visiba/api-vcs-client-v2';
import { FormDataProvider } from './form_data_provider';

export class FormDataProviderRespondant implements FormDataProvider {
	private unitId: number;
	private formId: number;
	private respondantId: number;

	constructor(
		unitId: number,
		formId: number,
		respondantId: number,
		private readonly formsApiService: DynamicFormsApiService,
	) {
		this.unitId = unitId;
		this.formId = formId;
		this.respondantId = respondantId;
		// Empty
	}

	public async getForm(): AsyncResult<FormGraphApiModel> {
		const result = await this.formsApiService.getById(this.unitId, this.formId);

		if (result.err) {
			return Err(result.err);
		}

		return Ok(result.ok.data);
	}

	public async getAnswers(): AsyncResult<DynamicFormAnswers> {
		const result = await this.formsApiService.getRespondant(this.unitId, this.respondantId);

		if (result.err) {
			return Err(result.err);
		}

		return Ok({
			completed: result.ok.data.Completed,
			answers: result.ok.data.Answers.map((answer) => ({
				boolValue: answer.BoolValue,
				choices: answer.Choices,
				intValue: answer.IntValue,
				questionId: answer.QuestionId,
				stringValue: answer.StringValue,
			})),
		});
	}

	public async answer(answers: DynamicFormAnswer[]): AsyncResult {
		const result = await this.formsApiService.answer(this.unitId, this.respondantId, answers);

		if (result.err) {
			return Err(result.err);
		}

		return Ok();
	}

	public async setCompletion(): AsyncResult {
		const result = await this.formsApiService.setCompletion(this.unitId, this.respondantId);

		if (result.err) {
			return Err(result.err);
		}

		return Ok();
	}
}
